import React                      from "react";
import { GiDiamondRing, GiWatch } from "react-icons/gi";
import { Button, Center }         from "@chakra-ui/react";

import CallToAction      from "@interness/theme-sonora/src/components/CallToAction/CallToAction";
import Heading           from "@interness/web-core/src/components/text/Heading/Heading";
import Spacer            from "@interness/web-core/src/components/structure/Spacer/Spacer";
import Wrapper           from "@interness/web-core/src/components/structure/Wrapper/Wrapper";
import SEO               from "@interness/web-core/src/components/modules/SEO/SEO";
import LiveAnnouncements from "@interness/web-core/src/components/structure/LiveAnnouncements/LiveAnnouncements";
import RandomShopItems   from "@interness/ecommerce-addon/src/components/RandomShopItems/RandomShopItems";
import Link              from "@interness/web-core/src/components/elements/Link/Link";

function IndexPage({ data }) {
  return (
    <>
      <SEO title={"Startseite"} />
      <Wrapper>
        <section>
          <Spacer />
          <Heading tag={"h2"} icon={<GiWatch />}>
            Out of Collection & Special Offer
          </Heading>
          <RandomShopItems />
          <Spacer />
          <Center>
            <Button
              sx={{ textDecoration: "none" }}
              colorScheme="brand"
              primary
              as={Link}
              to="/shop"
            >
              Mehr Produkte entdecken
            </Button>
          </Center>
        </section>
        <Spacer />
      </Wrapper>
      <Wrapper>
        <CallToAction />
      </Wrapper>
    </>
  );
}

export default IndexPage;
